import { getDefaultShopConfig } from './default';
import { getConditionsFilterConfig } from '../filters/condition';
import * as custom from '../filters/marketplace-custom-config';
import { getSizeFilterConfig } from '../filters/size';
import { getColorFilterConfig } from '../filters/color';
import { getBrandDirectFilterConfig } from '../filters/brandDirect';
import { BuilderSections } from '../../util/builder';

const sizes = [
  'King',
  'Queen',
  'Full',
  'Twin',
  'Twin XL',
  'Standard',
  'Euro',
  'Toddler',
  'Small',
  'Medium',
  'Large',
  'XL',
];

export const beddysShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    getConditionsFilterConfig(),
    getSizeFilterConfig({ sizes }),
    getColorFilterConfig(),
    getBrandDirectFilterConfig(),
  ],
  builderConfig: {
    sections: {
      [BuilderSections.LandingPageInfoContent]: '340b0b3c880f4d07a5185aa06cd83097',
    },
  },
};
